import React from 'react';
import PageWrapper from '../components/PageWrapper';
import HeroSection from '../components/HeroSection';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const Bewerber = () => {
  const scrollToForm = () => {
    document.getElementById('bewerber-form').scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <PageWrapper>
      <HeroSection 
        title="Ihre Karriere im Norden" 
        subtitle="Wir finden den Job, der zu Ihrem Leben passt."
        bgImage="https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?auto=format&fit=crop&w=1920&q=80"
        cta1={{ text: 'Jetzt Profil anlegen', link: '#bewerber-form' }}
      />

      <section className="py-16 bg-white">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-blue-900 mb-4">So unterstützen wir Sie</h2>
            <p className="text-lg text-slate-600 max-w-2xl mx-auto">
              Der erste Schritt zu Ihrem neuen Traumjob ist die Erstellung eines Bewerberprofils. 
              Füllen Sie dazu einfach unser Formular aus.
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 mb-12">
            {[
              { icon: 'FiSearch', title: 'Jobsuche', desc: 'Aktive Unterstützung bei der Suche nach passenden Stellen.' },
              { icon: 'FiTarget', title: 'Vermittlung', desc: 'Wir schlagen Sie proaktiv bei Top-Unternehmen vor.' },
              { icon: 'FiUsers', title: 'Begleitung', desc: 'Wir begleiten Sie im gesamten Bewerbungsprozess.' },
              { icon: 'FiLock', title: 'Vertraulich', desc: 'Ihre Daten werden streng vertraulich und DSGVO-konform behandelt.' }
            ].map((feature, idx) => (
              <div key={idx} className="bg-slate-50 p-6 rounded-xl text-center border border-slate-100">
                <SafeIcon name={feature.icon} className="h-8 w-8 text-cyan-600 mx-auto mb-4" />
                <h3 className="font-bold text-blue-900 mb-2">{feature.title}</h3>
                <p className="text-sm text-slate-600">{feature.desc}</p>
              </div>
            ))}
          </div>

          <div className="text-center">
            <button 
              onClick={scrollToForm}
              className="bg-cyan-600 hover:bg-cyan-500 text-white font-bold py-4 px-10 rounded-xl transition-all shadow-lg hover:shadow-cyan-500/30 text-lg"
            >
              Zum Bewerberformular
            </button>
          </div>
        </div>
      </section>

      <section id="bewerber-form" className="py-16 bg-slate-100">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-10">
            <h2 className="text-3xl font-bold text-blue-900 mb-4">Mitarbeiter Profil anlegen</h2>
            <p className="text-slate-600">
              Füllen Sie das untenstehende Formular aus. Ihre Daten werden sicher übertragen und wir melden uns zeitnah bei Ihnen.
            </p>
          </div>

          {/* Container für das Google Formular */}
          <div className="bg-white rounded-2xl shadow-xl overflow-hidden border border-slate-200 w-full">
            <iframe 
              src="https://docs.google.com/forms/d/e/1FAIpQLSfuiHMKH-XXOyTDjQH_ET83rxDFpKve48S85P0qJ-Jp1BwxwA/viewform?embedded=true" 
              width="100%" 
              height="1400" 
              frameBorder="0" 
              marginHeight="0" 
              marginWidth="0"
              className="w-full bg-white"
              title="Bewerbung Nordblick Recruiting"
            >
              Wird geladen…
            </iframe>
          </div>
        </div>
      </section>
    </PageWrapper>
  );
};

export default Bewerber;